import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'
import { CoursePlanData } from '~/store/apis/ContractCoursePlan'

/**
 * 新着お知らせ確認
 */
import { ApiTaNt010 } from '~/endpoints/ApiTaNt010'

/**
 * お知らせバッジフラグ
 */
export const noticeBadgeFlgType = {
  ShowBadge: 0, // バッジ表示
  HideBadge: 1, // バッジ非表示
} as const
export type NoticeBadgeFlgType = typeof noticeBadgeFlgType[keyof typeof noticeBadgeFlgType]

// State types
export interface StateNewNotices {
  isShowNoticeBadge: boolean
  noticeNumber: number
  statusCode: number
  error: {
    messageId: string
    message: string
  } | null
}
export const getEmptyStateNewNotices = (): StateNewNotices => ({
  isShowNoticeBadge: false,
  noticeNumber: 0,
  statusCode: 0,
  error: null,
})

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/NewNotices',
})
export default class NewNotices extends VuexModule {
  // States
  private state_: StateNewNotices = getEmptyStateNewNotices()

  // Getters

  get result(): StateNewNotices {
    return this.state_
  }

  // Mutations

  @Mutation
  updateNewNotices(value: StateNewNotices) {
    this.state_ = value
  }

  static readonly MUTATION_NAME_UPDATE_STATE = 'updateNewNotices'

  // Actions

  @Action
  clear() {
    this.context.commit(NewNotices.MUTATION_NAME_UPDATE_STATE, getEmptyStateNewNotices())
  }

  @Action
  async getNewNotices(coursePlandata: CoursePlanData) {
    logger.trace('in: getNewNotices')
    const api = new ApiTaNt010.Api()

    // API
    const result = await api.get<StateNewNotices>(
      {
        query: coursePlandata,
      },
      // Success
      (data, status) => {
        return {
          isShowNoticeBadge: data.noticeBadgeFlg === noticeBadgeFlgType.ShowBadge,
          noticeNumber: data.noticeNumber,
          statusCode: status,
          error: null,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return {
          isShowNoticeBadge: getEmptyStateNewNotices().isShowNoticeBadge,
          noticeNumber: getEmptyStateNewNotices().noticeNumber,
          statusCode: status,
          error: {
            messageId: data.error.messageId,
            message: data.error.message,
          },
        }
      }
    )

    const commitdata: StateNewNotices = getEmptyStateNewNotices()
    if (result) {
      commitdata.statusCode = result.statusCode
      commitdata.error = result.error
      if (commitdata.error === null) {
        commitdata.isShowNoticeBadge = result.isShowNoticeBadge
        commitdata.noticeNumber = result.noticeNumber
      }
    }
    this.context.commit(NewNotices.MUTATION_NAME_UPDATE_STATE, commitdata)
  }
}
